import { avgEngagementRatePerTweetConfig } from '@/lib/analytics/kpis/twitter/avgEngagementRatePerTweet';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerEngagementConfig = {
    ...avgEngagementRatePerTweetConfig,
    id: 'engagement_rate',
    name: 'kpi.twitter.mediaviewer.engagement_rate',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
